import React, { memo, useCallback } from 'react';
import { Group, Arrow, Circle } from 'react-konva';

export const Connector = memo(({ 
  id,
  points,
  stroke = '#000',
  strokeWidth = 2,
  fill = '#000',
  isSelected,
  onSelect,
  onChange,
  pointerLength = 10,
  pointerWidth = 10
}) => {
  const [x1, y1, x2, y2] = points;

  // Memoized callbacks
  const handleSelect = useCallback(() => {
    onSelect(id);
  }, [id, onSelect]);

  const handleChange = useCallback((changes) => {
    onChange(id, changes);
  }, [id, onChange]);

  const handleDragMoveStart = useCallback((e) => {
    const newPoints = [...points];
    newPoints[0] = e.target.x();
    newPoints[1] = e.target.y();
    handleChange({ points: newPoints });
  }, [points, handleChange]);

  const handleDragMoveEnd = useCallback((e) => {
    const newPoints = [...points];
    newPoints[2] = e.target.x();
    newPoints[3] = e.target.y();
    handleChange({ points: newPoints });
  }, [points, handleChange]);

  return (
    <Group id={id} name={id}>
      <Arrow
        points={points}
        stroke={isSelected ? '#3d9168' : stroke}
        strokeWidth={isSelected ? strokeWidth + 1 : strokeWidth}
        fill={fill}
        pointerLength={pointerLength}
        pointerWidth={pointerWidth}
        onClick={handleSelect}
        onTap={handleSelect}
      />
      
      {/* Editable endpoints when selected */}
      {isSelected && (
        <>
          {/* Start point handle */}
          <Circle
            x={x1}
            y={y1}
            radius={6}
            fill="#3d9168"
            stroke="#fff"
            strokeWidth={2}
            draggable
            onDragMove={handleDragMoveStart}
          />
          
          {/* End point handle */}
          <Circle
            x={x2}
            y={y2}
            radius={6}
            fill="#3d9168"
            stroke="#fff"
            strokeWidth={2}
            draggable
            onDragMove={handleDragMoveEnd}
          />
        </>
      )}
    </Group>
  );
});
